import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { useSelector } from "react-redux";

import { SubTab } from "../Cms/TabNInput";
import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { API } from "../../constant/api";
import ViewAll from "../Coaches/ViewAllRoll";
import ViewPaymentHistory from "./ViewPaymentHistory";
import { Link } from "react-router-dom";

const Approved = () => (
  <span className="label label-lg label-light-success label-inline">
    Approved
  </span>
);

const Rejected = () => (
  <span className="label label-lg label-light-danger label-inline">
    Rejected
  </span>
);

const Pending = () => (
  <span className="label label-lg label-light-warning label-inline">
    Pending
  </span>
);

const OnHold = () => (
  <span className="label label-lg label-light-danger label-inline">
    On-Hold
  </span>
);

const Pilot = () => (
  <span className="label label-lg label-light-info label-inline">
    Pilot
  </span>
);

const ViewOne = (props) => {
  const { id: seekerId } = props.match.params;

  const [userData, setUserData] = useState([]);

  const { response: responseUserData, request: requestUserData } = useRequest();


  const { date_format } = useSelector((state) => state.setting);

  useEffect(() => {
    requestUserData("GET", `club/${seekerId}`);

    document.title = "View Club - Calevalab";
  }, []);


  useEffect(() => {
    if (responseUserData) {
      const {
        firstName,
        lastName,
        email,
        approvalStatus,
        createdAt, other_fields,
        organizationCode, subscription, coaches, athletes,clubManagers
      } = responseUserData.user;

      let phoneNumber = (other_fields && other_fields.contact) ? other_fields.contact : '';
      if (phoneNumber) {
        if (other_fields && other_fields.countryCode && other_fields.countryCode.dial_code) {
          phoneNumber = other_fields.countryCode.dial_code + ' ' + phoneNumber;
        }
      } else {
        phoneNumber = '-';
      }

      setUserData([
        { title: "First Name", value: firstName ? firstName : '-' },
        { title: "Last Name", value: lastName ? lastName : '-' },
        { title: "Email", value: email ? email : '-' },
        { title: "Logo", value: (other_fields && other_fields.profilePic) ? <img className="imageMedia" src={`${other_fields.profilePic}`} /> : '-' },
        { title: "Code", value: organizationCode ? organizationCode : '-' },
        { title: "Gender", value: (other_fields && other_fields.gender) ? other_fields.gender : '-' },
        { title: "Date of Birth", value: (other_fields && other_fields.dob) ? <Moment format={date_format}>{other_fields.dob}</Moment> : '-' },
        { title: "Country", value: (other_fields && other_fields.country && other_fields.country.name) ? other_fields.country.name : '-' },
        { title: "Contact", value: phoneNumber },
        { title: "Organization Name", value: (other_fields && other_fields.organizationName) ? other_fields.organizationName : '-' },
        { title: "Organization Short Name", value: (other_fields && other_fields.organizationShortName) ? other_fields.organizationShortName : '-' },
        { title: "Organization Address", value: (other_fields && other_fields.organizationAddress) ? other_fields.organizationAddress : '-' },
        { title: "Organization City", value: (other_fields && other_fields.organizationCity) ? other_fields.organizationCity : '-' },
        { title: "Sport", value: (other_fields && other_fields.sportName && other_fields.sportName.name) ? other_fields.sportName.name : '' },
        { title: "Organization Website", value: (other_fields && other_fields.organizationWebsite) ? other_fields.organizationWebsite : '-' },

        { title: "Subsciption Status", value: (subscription && subscription?.subscriptionId?.status) ? subscription.subscriptionId.status : 'Free' },
        { title: "Free Account Limit", value: (subscription && subscription.freeAccountsLimit) ? subscription.freeAccountsLimit : '-' },
        { title: "Grace Period", value: (subscription && subscription.gracePeriod) ? `${subscription.gracePeriod} Days` : '-' },
        // { title: "total athletes", value: athletes ? athletes : '0' },
        // { title: "total coaches", value: coaches ? coaches : '0' },
        { title: "Total Athletes", value: athletes ? <Link to={`/athletes?clubId=${seekerId}`} className="text-primary tableLink">{athletes}</Link> : '0' },
        { title: "Total Coaches", value: coaches ? <Link to={`/coaches?clubId=${seekerId}`} className="text-primary tableLink">{coaches}</Link> : '0' },
        {title:"Total Club Managers",value: clubManagers ? clubManagers : '0'},
        {
          title: "Is Pilot Account",
          value:
            subscription && typeof subscription?.isPilotAccount === 'boolean'
              ? subscription?.isPilotAccount
                ? 'Yes'
                : 'No'
              : '-'
        },
        {
          title: "Registered On",
          value: <Moment format={date_format}>{createdAt}</Moment>,
        },
        {
          title: "Status",
          value: approvalStatus === "Approved" ? <Approved /> :
            approvalStatus === "Pending" ? <Pending /> :
              approvalStatus === "On-Hold" ? <OnHold /> :
                approvalStatus === "Pilot" ? <Pilot /> :
                  <Rejected />
        },
      ]);
    }
  }, [responseUserData]);

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="View Club"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/clubs", name: "Back To Clubs" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom gutter-b">
            <div className="card-header card-header-tabs-line">
              <div className="card-toolbar">
                <ul
                  className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                  role="tablist"
                >
                  {["Club Information"].map((data, index) => (
                    <SubTab key={index} name={data} index={0} />
                  ))}
                  {["Role Information"].map((data, index) => (
                    <SubTab key={index} name={data} index={1} />
                  ))}
                  {["Invoicing and Payment History"].map((data, index) => (
                    <SubTab key={index} name={data} index={3} />
                  ))}
                </ul>
              </div>
            </div>

            <div className="card-body px-0">
              <div className="tab-content px-10">
                <div
                  className={`tab-pane active`}
                  id={`kt_apps_contacts_view_tab_0`}
                  role="tabpanel"
                >
                  {userData.length > 0 &&
                    userData.map((user, index) => (
                      <div key={index} className="form-group row my-2">
                        <label className="col-4 col-form-label">
                          {user.title}
                        </label>
                        <div className="col-8">
                          <span className="form-control-plaintext font-weight-bolder">
                            {user.value}
                          </span>
                        </div>
                      </div>
                    ))}

                  <div className="row"></div>
                </div>
                <div
                  className={`tab-pane `}
                  id={`kt_apps_contacts_view_tab_1`}
                  role="tabpanel"
                >

                  <ViewAll userData={responseUserData?.roles || []} />
                </div>
                <div
                  className={`tab-pane `}
                  id={`kt_apps_contacts_view_tab_3`}
                  role="tabpanel"
                >

                  <ViewPaymentHistory transactions={responseUserData?.transactions || []} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
